<div class="row tab-view">
  <div class="col-12">
    <p-tabView class="number-of-employee-tab-header" (onChange)="numberOfEmployeesTabChange()" [activeIndex]="filter.relativeYears ? 1 : 0">
      <p-tabPanel header="Years of Study">
        <div class="row filter-type-selection-header">
          <div class="col-12 text-right">{{ filter.absoluteYears?.length || 0 }} Selected</div>
        </div>
        <div class="row filter-type-selection-body">
          <div class="col-6">
            <p-table
              [value]="numberOfEmployeesAbsoluteYears"
              (click)="formDirty = true"
              [(selection)]="filter.absoluteYears"
              [scrollable]="true"
              scrollHeight="163px"
              (onRowSelect)="sortSelection(filter.absoluteYears)"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 3em" class="table-filter-row-header"><p-tableHeaderCheckbox></p-tableHeaderCheckbox>Annual Data</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr [pSelectableRow]="rowData" class="table-filter-row-data">
                  <td><p-tableCheckbox [value]="rowData"></p-tableCheckbox>{{ rowData.label }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="col-6">
            <p-tree
              class="selected-tree"
              (click)="formDirty = true"
              [value]="filter.absoluteYears"
              [(selection)]="filter.absoluteYears"
              selectionMode="multiple"
              selectionMode="checkbox"
              emptyMessage=" "
            ></p-tree>
          </div>
        </div>
        <fieldset ngModelGroup="”numberOfEmployeesAbsoluteYears”">
          <input type="hidden" [(ngModel)]="filter.absoluteYears" name="absoluteYears" #absoluteYears="ngModel" required />
          <div class="row">
            <div class="col=12">
              <span class="help-block">
                <span *ngIf="formDirty && (!this.filter.absoluteYears || this.filter.absoluteYears.length < 1)"> Please select an option </span>
              </span>
            </div>
          </div>
        </fieldset>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
<div class="row mt-4" *ngIf="isNonBvdSelected">
  <div class="col-12">
    <div class="form-group">
      <div class="usrDefined">
        <div class="col-sm-9 rd-btn">
          <label class="me-3">Pass If NA:</label>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="isPassIfNa_1"
              name="isPassIfNa_1"
              [value]="true"
              class="custom-control-input"
              [disabled]="readOnly || disablePassIfNa"
              [(ngModel)]="filter.isPassIfNa"
            />
            <label class="custom-control-label" for="isPassIfNa_1">Yes</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              id="isPassIfNa_2"
              name="isPassIfNa_2"
              [value]="false"
              class="custom-control-input"
              [disabled]="readOnly || disablePassIfNa"
              [(ngModel)]="filter.isPassIfNa"
            />
            <label class="custom-control-label" for="isPassIfNa_2">No</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" [ngClass]="{ 'mt-4': !isNonBvdSelected }">
  <div class="col-12">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(validCriteria) }">
      <span class="ey-float-label">
        <select
          class="form-control form-select"
          id="validCriteria"
          name="validCriteria"
          #validCriteria="ngModel"
          [(ngModel)]="filter.criteriaToBeValid"
          [disabled]="readOnly || (!this.filter.absoluteYears && !this.filter.relativeYears)"
          appLabelFloat
        >
          <option [ngValue]="numberOfEmployeesValidCriteria.AtLeastOne" selected>
            {{ numberOfEmployeesValidCriteria.AtLeastOne.toString() }}
          </option>
          <option [ngValue]="numberOfEmployeesValidCriteria.AllSelected">
            {{ numberOfEmployeesValidCriteria.AllSelected }}
          </option>
        </select>
        <label for="validCriteria">Criteria to be valid</label>
      </span>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(minimumValue) }">
      <span class="ey-float-label">
        <input
          class="form-control"
          id="minimumValue"
          name="minimumValue"
          pattern="{{ regularExpressionPattern.NumberPattern }}"
          [(ngModel)]="filter.minimumValue"
          [disabled]="readOnly"
          #minimumValue="ngModel"
          maxlength="9"
          [appRequiredIf]="!filter.maximumValue"
          appLabelFloat
        />
        <label for="minimumValue">Minimum</label>
      </span>
      <span class="help-block" *ngIf="minimumValue.errors?.pattern"> Please input only numeric values </span>
      <span class="help-block">
        <span *ngIf="ShowValidationMessage(minimumValue) && minimumValue.errors?.requiredIf && maximumValue.errors?.requiredIf">
          Enter a value for Minimum, Maximum, or both
        </span>
      </span>
    </div>
  </div>
  <div class="col-6">
    <div class="form-group" [ngClass]="{ 'has-error': ShowValidationMessage(maximumValue) }">
      <span class="ey-float-label">
        <input
          class="form-control"
          id="maximumValue"
          name="maximumValue"
          pattern="{{ regularExpressionPattern.NumberPattern }}"
          [(ngModel)]="filter.maximumValue"
          [disabled]="readOnly"
          #maximumValue="ngModel"
          maxlength="9"
          [appRequiredIf]="!filter.minimumValue"
          [appMin]="filter.minimumValue"
          appLabelFloat
        />
        <label for="maximumValue">Maximum</label>
      </span>
      <span class="help-block" *ngIf="maximumValue.errors?.pattern"> Please input only numeric values </span>
      <span class="help-block">
        <span *ngIf="ShowValidationMessage(maximumValue) && !CheckEndGreaterThanBeginning(filter.minimumValue, filter.maximumValue)">
          Maximum value must be greater than Minimum Value
        </span>
      </span>
    </div>
  </div>
</div>
